import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "233",
  "slug": "how-satellite-imagery-changed-the-world",
  "title": "How Satellite Imagery Became a Record of Change",
  "excerpt": "Weather observations, reconnaissance, and land monitoring developed different ways to observe Earth.",
  "date": "2026-03-11",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?w=800&q=80",
  "readTime": "2 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Satellite imaging developed along several paths. TIROS-1 began observing weather in 1960. In the same year, the CORONA reconnaissance programme recovered usable film from orbit. Landsat 1, launched in 1972, began a long-running record of the land surface."
    },
    {
      "type": "paragraph",
      "text": "These missions answered different questions. A frequent broad view of clouds serves a different purpose from detailed reconnaissance or repeated measurements of land cover. There is no single image product that provides every place, every day, at the highest available resolution."
    },
    {
      "type": "heading",
      "text": "Repeated views make change visible"
    },
    {
      "type": "paragraph",
      "text": "An archive lets you compare a place with its earlier appearance: a reservoir at different water levels, a city's expanding edge, or forest before and after a disturbance. To interpret the difference, check acquisition dates, cloud cover, season, resolution, and processing. A change in colour may come from how the image was made."
    },
    {
      "type": "heading",
      "text": "A basemap is a selected view"
    },
    {
      "type": "paragraph",
      "text": "A consumer satellite layer usually combines selected imagery rather than showing Earth live. It may include aerial photography, and adjoining areas can come from different dates. Zooming farther in does not create new detail beyond the source resolution."
    },
    {
      "type": "paragraph",
      "text": "Use a dated observation archive for a claim about when something changed. Use a basemap to explore its geographic context, while checking what the imagery actually represents."
    }
  ],
  "sources": [
    {
      "title": "NASA: TIROS-1 and other milestones",
      "url": "https://www.nasa.gov/specials/timeline/index.html"
    },
    {
      "title": "NRO: CORONA history",
      "url": "https://www.nro.gov/About-NRO/history/history-corona/"
    },
    {
      "title": "NASA: Landsat 1",
      "url": "https://science.nasa.gov/mission/landsat-1/"
    }
  ],
  "relatedSlugs": [
    "what-are-landsat-satellites",
    "how-old-are-google-maps-satellite-images"
  ]
};
